The reason why a position was not posted on SEEK.
